var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{class:[
      'rounded-md',
      'v-cardgrid',
      'mx-auto',
      'mb-4',
      { 'on-hover': hover } ],attrs:{"elevation":hover ? 8 : 2,"max-width":_vm.width}},[_vm._t("default")],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }